// src/AuthGate.jsx
import { useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, db } from "./FirebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import { Navigate } from "react-router-dom";
import { Spin } from "antd";

const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

export default function AuthGate({ children }) {
  const [checking, setChecking] = useState(true);
  const [userDoc, setUserDoc] = useState(null);
  const [needLogin, setNeedLogin] = useState(false);
  const [needTerms, setNeedTerms] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      try {
        if (!user) {
          setNeedLogin(true);
          return;
        }

        const ref = doc(db, "users", user.uid);
        const snap = await getDoc(ref);
        const data = snap.data();

        if (!data?.lastLoginAt) {
          await signOut(auth);
          setNeedLogin(true);
          return;
        }

        const lastLoginMs = data.lastLoginAt.toDate().getTime();
        if (Date.now() - lastLoginMs > THIRTY_DAYS_MS) {
          await signOut(auth);
          setNeedLogin(true);
          return;
        }

        if (!data.agreeTerms || !data.agreePrivacy) {
          setNeedTerms(true);
          return;
        }

        setUserDoc(data);
      } catch (e) {
        console.error("AuthGate error", e);
        await signOut(auth);
        setNeedLogin(true);
      } finally {
        setChecking(false);
      }
    });

    return () => unsub();
  }, []);

  if (checking) {
    return <Spin size="large" style={{ margin: 200 }} />;
  }

  if (needLogin) {
    return <Navigate to="/login" replace />;
  }

  if (needTerms) {
    return <Navigate to="/terms" replace />;
  }

  return children;
}
